import React from 'react';
import { MyVwContextType } from '../typings/main';

export const MyVwContext = React.createContext<MyVwContextType | null>(null);

export function useMyVwContext(): MyVwContextType {
  const myVwContext = React.useContext(MyVwContext);

  if (!myVwContext) {
    throw new Error('No my vw context value was provided.');
  }

  return myVwContext;
}
